import jwtDecode from 'jwt-decode'

const jwt = localStorage.getItem('pn_auth_access')

try {
  const decoded = jwtDecode(jwt)
  if (decoded.exp * 1000 < new Date().valueOf()) {
    localStorage.removeItem('pn_auth_access')
    localStorage.removeItem('pn_user_email')
    localStorage.removeItem('pn_user_confirmed')
  }
} catch {
  localStorage.removeItem('pn_auth_access')
  localStorage.removeItem('pn_user_email')
  localStorage.removeItem('pn_user_confirmed')
}
